<template>
  <div class="indicator">
    <div class="indicatorbanner">
      <div class="imgBg">
        <!-- <img v-if="bannerList.adverImage" :src="bannerList.adverImage" alt=""> -->
        <img src="../../../../static/images/phbanner.png" alt />
      </div>
      <div class="indicatorCon">
        <div class="conleft">
          <div 
            v-if="btTitels.columnTitle"
            :class="[btTitels.columnTitle.length > 25 ? 'leftTitle1' : 'leftTitle']"
          >{{btTitels.columnTitle}}</div>
          <div class="leftCon">
            <span>{{btTitels.columnDesc}}</span>
            
          </div>
          <div class="leftBtn" @click="goIndicatorSeach()">更多排行榜</div>
        </div>
        <div class="conRight"></div>
      </div>
    </div>

    <div class="indicatorSearchBox">
     <div class="listTitle">产品排行</div>
      <div class = 'seeMoreBox'>
        <div class="seeMore" @click="goIndicatorSeach()"><p>查看更多排行</p><img style = "width:10px;height:10px;margin-left:5px " src="../../../../static/images/kpMore.svg" alt=""></div>
      </div>
      <div class="searchBox">
        <div>根据选定的产品分类和特征指标进行排行</div>
        <div style="margin:0 15px">
          <!-- <el-select
            v-model="value1"
            @change="flChange"
            filterable
            placeholder="请选择"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in ncClassList"
              :key="item.id"
              :label="item.catgName"
              :value="item.id"
            ></el-option>
          </el-select> -->
          <!--  -->
          <el-cascader
            v-model="value10"
            :options="ncClassList"
            :props="wbfcOpt"
            change-on-select
            @change="flChange">
          </el-cascader>
        </div>
        <div>
          <!-- <el-select v-model="value2" placeholder="请选择">
                    <el-option
                    v-for="item in options2"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
          </el-select>-->
          <el-select
            class="classify_select"
            v-model="value2"
            @change="zbChange"
            filterable
            placeholder="请选择"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in zbNameList"
              :key="item.compoundId"
              :label="item.indexName"
              :value="item.compoundId"
            ></el-option>
          </el-select>
        </div>
        
      </div>
      <div class="rankingListBox">
        <!-- 产品分类 -->

        <!-- <div class="box">
              <div class="title">{{rightTitles.plTitle}}{{rightTitles.zbName}}/每100单位排行</div>
              <div class="cont" v-if="plList && plList.length>0">
                <ul class="clearfix">
                  <li :class="[cpIndex1 == index ? 'liActive' : '']" v-for="(item,index) in plList" :key="index" @click="cpClickFn(item,1,index)">
                    <div :class="[index > 2 ?'rankingList_bg4 rankingList_bg' : 'rankingList_bg rankingList_bg'+index]">
                      <img v-if="item.imageUrl" :src="commonUrl+ item.imageUrl" alt="icon">
                      <span>{{item.catgName.charAt(0)}}</span>
                    </div>
                    <div>{{item.catgName}}</div>
                    <div><el-progress :show-text="false" :percentage="Number(item.itemValue ? item.itemValue : 0)" color="#6f7ad3"></el-progress></div>
                    <div>{{item.itemValue}}<span v-if="item.itemValue">{{item.unitValue}}</span></div>
                  </li>
                </ul>
              </div>
              <div class="cont_no_data" v-else>
                <img src="../../../../static/images/no_data.svg" alt="">
              </div>
        </div>-->
        <div class="box">
          <div
             v-if="rightTitles.zbName"
            :class="[rightTitles.title.length + rightTitles.zbName.length > 12 ? (rightTitles.title.length + rightTitles.zbName.length > 17 ? 'title2' : 'title1') : 'title']"
          >
          
          <span class="span1">{{rightTitles.title}}</span>
          <span class="span2">{{rightTitles.zbName}}/每100单位</span>
          
          </div>
          <div class="cont" v-if="plList && plList.length>0">
            <ul class="clearfix">
              <li v-for="(item,index) in plList" :key="index" @mouseenter="debounce(item,1,index)">
                <div class="cont-1">
                  <img v-if="index == 0" src="../../../../static/images/paihang1.png" alt />
                  <img v-if="index == 1" src="../../../../static/images/paihang2.png" alt />
                  <img v-if="index == 2" src="../../../../static/images/paihang3.png" alt />
                </div>
                <div
                  :class="[cpIndex1 == index  ? 'liActive cont-2' : index < 3 ? 'cont-2-mr cont-2' : 'cont-2' ]"
                >
                  <div
                    :class="[index > 2 ?'rankingList_bg4 rankingList_bg div1' : 'rankingList_bg div1 rankingList_bg'+index]"
                  >
                    <img v-if="item.imageUrl" :src="commonUrl+ item.imageUrl" alt="icon" />
                    <span>{{item.catgName.charAt(0)}}</span>
                  </div>
                  <div class="div2">{{item.catgName}}</div>
                  <div class="div3">
                    <el-progress
                      :show-text="false"
                      :percentage="Number(item.itemValue ? (item.itemValue >100 ?100 : item.itemValue ) : 0)"
                      color="#6f7ad3"
                    ></el-progress>
                  </div>
                  <div class="div4">
                    {{item.itemValue}}
                    <span v-if="item.itemValue">{{item.unitValue}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="cont_no_data" v-else>
            <img src="../../../../static/images/no_data.svg" alt />
          </div>
        </div>
        <!-- 产品 -->
        <div class="box">
          <div
           
            :class="[rightTitles.plTitle.length + rightTitles.zbName.length > 12 ? (rightTitles.plTitle.length + rightTitles.zbName.length > 17 ? 'title2' : 'title1') : 'title']"
          >
          <span class="span1">{{rightTitles.plTitle}}</span>
          <span class="span2">{{rightTitles.zbName}}/每100单位</span>
          </div>
          <div class="cont" v-if="cpList && cpList.length>0">
            <ul class="clearfix">
              <li
                
                v-for="(item,index) in cpList"
                :key="index"
                @click="debounce(item,2,index)"
              >
                <div class="cont-1">
                  <img v-if="index == 0" src="../../../../static/images/paihang1.png" alt />
                  <img v-if="index == 1" src="../../../../static/images/paihang2.png" alt />
                  <img v-if="index == 2" src="../../../../static/images/paihang3.png" alt />
                </div>
                <div
                  :class="[cpIndex2 == index  ? 'liActive cont-2' : index < 3 ? 'cont-2-mr cont-2' : 'cont-2' ]"
                >
                  <div
                    :class="[index > 2 ?'rankingList_bg4 rankingList_bg div1' : 'rankingList_bg div1 rankingList_bg'+index]"
                  >
                    <img v-if="item.imageUrl" :src="commonUrl+ item.imageUrl" alt="icon" />
                    <span v-else>{{item.catgName.charAt(0)}}</span>
                    <!-- <img v-else src="../../../../static/images/pro_img.png" alt /> -->
                  </div>
                  <div class="div2">{{item.catgName}}</div>
                  <div class="div3">
                    <el-progress
                      :show-text="false"
                      :percentage="Number(item.itemValue ? (item.itemValue >100 ?100 : item.itemValue ) : 0)"
                      color="#6f7ad3"
                    ></el-progress>
                  </div>
                  <div class="div4">
                    {{item.itemValue}}
                    <span v-if="item.itemValue">{{item.unitValue}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="cont_no_data" v-else>
            <img src="../../../../static/images/no_data.svg" alt />
          </div>
        </div>
        <!-- 产品品种 -->
        <div class="box">
          <!-- <div
            :class="[rightTitles.cpTitle.length + rightTitles.zbName.length > 12 ? (rightTitles.cpTitle.length + rightTitles.zbName.length > 17 ? 'title2' : 'title1') : 'title']"
          >{{rightTitles.cpTitle}}{{rightTitles.zbName}}/每100单位排行</div>
          <div class="cont" v-if="pzList && pzList.length>0">
            <ul class="clearfix">
              <li v-for="(item,index) in pzList" :key="index">
                <div class="cont-1">
                  <img v-if="index == 0" src="../../../../static/images/paihang1.png" alt />
                  <img v-if="index == 1" src="../../../../static/images/paihang2.png" alt />
                  <img v-if="index == 2" src="../../../../static/images/paihang3.png" alt />
                </div>
                <div :class=" [index < 3 ? 'cont-2-mr cont-2' : 'cont-2' ]">
                  <div
                    :class="[index > 2 ?'rankingList_bg4 rankingList_bg div1' : 'rankingList_bg div1 rankingList_bg'+index]"
                  >
                    <img v-if="item.imageUrl" :src="commonUrl+ item.imageUrl" alt="icon" />
                    <span>{{item.catgName.charAt(0)}}</span>
                  </div>
                  <div class="div2">{{item.catgName}}</div>
                  <div class="div3">
                    <el-progress
                      :show-text="false"
                      :percentage="Number(item.itemValue ? item.itemValue : 0)"
                      color="#6f7ad3"
                    ></el-progress>
                  </div>
                  <div class="div4">
                    {{item.itemValue}}
                    <span v-if="item.itemValue">{{item.unitValue}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div> -->
          <div class="cont_no_data1">
            <img src="../../../../static/images/tzSeachZw.png" alt />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    debounce(item, n, index, delay = 500) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.cpClickFn(item, n, index);
      }, delay);
    },
    getZbTypeList(){ //获取指标类型
      this.Axios({
        method:"post",
        url:Action.MDB_N_ALLONELIST,
        data:{}
      }).then(res =>{
          if(res.data.code === '000'){
            let typeIds = res.data.result.map(item => item.id);
            this.getZbNameList(typeIds);
          }else{
            this.$alert(res.data.msg || '系统错误...','错误提示',{
                cofirmButtonText:'确定',
                type:'error'
            })
          }
      }).catch(err =>{
        console.log(err)
      })
    },
    getSelectListFn() {
      //  获取分类指标数据
      this.Axios({
        method: "post",
        url: Action.FLOORCONFMAGE_OTHERFLOORINFO,
        data: {}
      })
        .then(res => {
          if (res.data.code === "000") {
            if (res.data.result.classItem) {
              this.options1.push({
                name: res.data.result.classItem.catgName,
                id: res.data.result.classItem.productClassId
              });
              this.options2.push({
                name: res.data.result.classItem.indexName,
                id: res.data.result.classItem.classId
              });
              this.value1 = res.data.result.classItem.productClassId;
              this.value2 = res.data.result.classItem.classId;
              this.queryForm.propertId = res.data.result.classItem.productClassId;
              this.queryForm.propertId1 = res.data.result.classItem.productClassId;
              this.queryForm.chemicalId = res.data.result.classItem.classId;
            }
            this.rightTitles.title = res.data.result.classItem.catgName;
            this.rightTitles.zbName = res.data.result.classItem.indexName;
            // this.getCpListFn();
            this.getPlListFn();
            this.getPzListFn();
          } else {
            this.$alert(res.data.msg || "系统错误...", "错误提示", {
              cofirmButtonText: "确定",
              type: "error"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    goIndicatorSeach() {
      this.$router.push({
        path: "./indicatorSeach",
        query: { productId: this.value1, zbId: this.value2 }
      });
    },
    sortBigsmallFn(data) {
      // 从大到小排序
      data.sort(function(a, b) {
        return Number(b.itemValue) - Number(a.itemValue);
      });
    },
    getCpListFn() {
      // 产品
      this.Axios({
        method: "post",
        url: Action.REPLENISH_RANKINGPRODUCTLIST,
        data: this.queryForm
      })
        .then(res => {
          if (res.data.code === "000") {
            this.cpList = res.data.result;
            if (this.cpList.length > 0) {
              this.rightTitles.cpTitle = res.data.result[0].catgName;
            }
            this.sortBigsmallFn(this.cpList);
          } else {
            this.$alert(res.data.msg || "系统错误...", "错误提示", {
              cofirmButtonText: "确定",
              type: "error"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getPlListFn() {
      //品类
      this.Axios({
        method: "post",
        url: Action.REPLENISH_RANKINGCATGLIST,
        data: this.queryForm
      })
        .then(res => {
          if (res.data.code === "000") {
            this.plList = res.data.result;
            if (this.plList.length > 0)
              this.sortBigsmallFn(this.plList);
              if(res.data.result && res.data.result.length>0){
                this.rightTitles.plTitle = res.data.result[0].catgName;
                // this.rightTitles.fristId = res.data.result[0].id;
                this.queryForm.propertId = res.data.result[0].id;
                this.getCpListFn();
              }
              
          } else {
            this.$alert(res.data.msg || "系统错误...", "错误提示", {
              cofirmButtonText: "确定",
              type: "error"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getPzListFn() {
      //品种
      this.Axios({
        method: "post",
        url: Action.REPLENISH_RANKINGVARIETLIST,
        data: this.queryForm
      })
        .then(res => {
          if (res.data.code === "000") {
            this.pzList = res.data.result;
            this.sortBigsmallFn(this.pzList);
            // cpClickFn(item, n, index) {
              // 右侧li点击
                
          } else {
            this.$alert(res.data.msg || "系统错误...", "错误提示", {
              cofirmButtonText: "确定",
              type: "error"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    cpClickFn(item, n, index) {
      // 右侧li点击
      if (n == 1) {
        this.cpIndex1 = index;
        this.rightTitles.plTitle = item.catgName;
        this.queryForm.propertId = item.id;
        this.cpIndex2 = 0;
        this.getCpListFn();
      } else {
        this.cpIndex2 = index;
        this.queryForm.propertId = item.id;
        this.rightTitles.cpTitle = item.catgName;
        window.open('productSeachDetails?id='+item.id,'_blank');
      }
    },
    // getBannerList(){ // 获取banner信息
    //   this.Axios({
    //     method:"post",
    //     url:Action.PROTAL_ADVER_LIST,
    //     data:{
    //       id:3
    //     }
    //   }).then(res =>{
    //       if(res.data.code === '000'){
    //         if(res.data.result.length>0){
    //           this.bannerList.adverImage =this.commonUrl+ res.data.result[0].adverMageListVos[0].adverImage;
    //           console.log(this.bannerList.adverImage,'adverImageadverImageadverImageadverImage')
    //         }

    //       }else{
    //         this.$alert(res.data.msg || '系统错误...','错误提示',{
    //             cofirmButtonText:'确定',
    //             type:'error'
    //         })
    //       }
    //   }).catch(err =>{
    //     console.log(err)
    //   })
    // },
    // getTreeData(data) { // 获取产品树
    //   for (let i = 0; i < data.length; i++) {
    //     if (!data[i].children) {
    //       // 最后一级没有数据将children变成undefined
    //       this.ncClassList.push(data[i])
    //     } else {
    //       this.ncClassList.push(data[i])
    //       // children不为空时继续调用该方法
    //       this.getTreeData(data[i].children);
    //     }
    //   return this.ncClassList;
    //   }
    // },
    // getTreeData(list, data) {
    //   data.map(item => {
    //     let children = item.children || [];
    //     list.push(item);
    //     if (children.length > 0) {
    //       this.getTreeData(list, children);
    //     }
    //   });
    //   return list;
    // },
    getTreeData(data, level = 1) {
      if (level > 2) {
        return null;
      }
      return data.map(({ id, catgName, pid, children }) => ({
        id,
        catgName,
        pid,
        children: this.getTreeData(children, level + 1)
      }));
    },

// const result = getTreeData(data);
// console.log(result);
    // filterLevel(list, level) {
    //   list.map(v => ({
    //     ...v,
    //     children: level <= 2 ? [] : this.filterLevel(v.children, level - 1)
    //   }));
    // },
    
    // filterLevel(list, data, level) {
    //   list.map(item => {
    //     data.push(item);
    //     let children = level <=2 ? item.children : [] ;
    //     if (children && children.length > 0) {
    //       this.filterLevel(children,data, level - 1);
    //     }
    //     // children: level <= 3 ? [] : this.filterLevel(v.children, level - 1)
    //   });
    //   return data
    // },
    getNcClassList(value) {
      //获取农产品分类
      this.Axios({
        method: "post",
        url: Action.REPLENISH_FINDCLASSMAGETREE,
        data: {}
      })
        .then(res => {
          if (res.data.code === "000") {
            // this.ncClassList = res.data.result[0].children.map((item) =>{

            // })
            // const filterLevel = (list, level = 2) => res.data.result[0].children.map(v => ({
            //   ...v, children: level <= 1 ? [] : filterLevel(v.children, level-1)
            // }))
            // this.filterLevel(res.data.result[0].children,2)
            // console.log(this.filterLevel(res.data.result[0].children,2));
            // console.log(this.getTreeData([],res.data.result[0].children),'getTreeData')
            // this.ncClassList = this.getTreeData([],res.data.result[0].children)
            this.ncClassList = this.getTreeData(res.data.result[0].children.splice(0,3))
            // if (res.data.result[0].children && res.data.result[0].children.length > 3) {
            //   this.ncClassList = this.getTreeData(res.data.result[0].children.splice(0,3));
            // }else{
            //   this.ncClassList = this.getTreeData(res.data.result[0].children);
            // }
            
            
            this.ncClassList.forEach((item)=>{
              item.children.forEach((items)=>{
                if(items.id == this.value1){
                  this.value10 = [items.pid,this.value1]
                }else{
                  if(this.value1 == item.id){
                    this.value10 = [item.id]
                  }
                }
              })
            })
          } else {
            this.$alert(res.data.msg || "系统错误...", "错误提示", {
              cofirmButtonText: "确定",
              type: "error"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getZbNameList(typeIds) {
      //获取指标名称
      this.Axios({
        method: "post",
        url: Action.POFTENINDEX_FINDPAGELIST,
        data: {}
      })
        .then(res => {
          if (res.data.code === "000") {
            this.zbNameList = res.data.result;
          } else {
            this.$alert(res.data.msg || "系统错误...", "错误提示", {
              cofirmButtonText: "确定",
              type: "error"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    zbChange(value) {
      // 指标名称下拉框
      this.value2 = value;
      console.log(value)
      this.queryForm.chemicalId = value;
      this.queryForm.propertId = this.queryForm.propertId1;
      this.cpIndex1 = 0;
      this.cpList = [];
      this.cpIndex2 = 0;
      this.rightTitles.zbName = "";
      // this.rightTitles.title = "";
      this.rightTitles.plTitle = "";
      this.rightTitles.cpTitle = "";
      this.$nextTick(() => {
        let aa = this.zbNameList
          .map((item, index) => {
            if (item.compoundId == value) {
              return item.indexName;
            }
          })
          .filter(items => items)
          .toString();
        this.rightTitles.zbName = aa;
      });
      // this.getCpListFn();
      this.getPlListFn();
      // this.getPzListFn();
    },
    flChange(value) {
      // 分类下拉框
      console.log(value)
      this.value1 = value.slice(',')[1] ? value.slice(',')[1] :value.slice(',')[0];
      this.queryForm.propertId = this.value1;
      this.queryForm.propertId1 = this.value1;
      this.cpList = [];
      // this.queryForm.propertId1 = this.value1
      this.cpIndex1 = 0;
      this.cpIndex2 = 0;
      this.rightTitles.title = "";
      this.rightTitles.plTitle = "";
      this.rightTitles.cpTitle = "";
      // this.ncClassList.forEach((item)=>{
      //         item.children.forEach((items)=>{
      //           if(items.id == this.value1){ 
      //             this.value10 = [items.pid,this.value1]
      //           }
      //         })
      //       })
        this.$nextTick(() => {
          // let aa = this.ncClassList
          //   .map((item, index) => {
          //     item.children.forEach((items)=>{
          //       if(this.value1 == items.id){
          //         return items.catgName
          //       }
          //     })
          //   })
          //   .filter(items => items)
          //   .toString();
          let aa;
          this.ncClassList.forEach((item, index) => {
              item.children.forEach((items)=>{
                if(this.value1 == items.id){
                   aa = items.catgName
                }else{
                  if(this.value1 == item.id){
                    aa = item.catgName
                  }
                  // aa = item.catgName
                }
              })
            })
          console.log(aa)
          console.log(this.value1)
          this.rightTitles.title = aa;
        });

      // this.getCpListFn();
      this.getPlListFn();
      // this.getPzListFn();
    },
    getTitles() {
      this.Axios({
        method: "post",
        url: Action.FLOORINDEX_GETFLOORINDEXSHOWOTHER,
        data: {
          sort: 7
        }
      })
        .then(res => {
          if (res.data.code === "000") {
            this.btTitels = res.data.result;
          } else {
            this.$alert(res.data.msg || "系统错误...", "错误提示", {
              cofirmButtonText: "确定",
              type: "error"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
    //
  },
  mounted() {
    this.getSelectListFn();
    //  this.getBannerList();
    this.getNcClassList();
    this.getZbTypeList();
    this.getTitles();
  },
  data() {
    return {
      customColor: "",
      percentage: 1,
      options1: [],
      options2: [],
      cpList: [],
      cpIndex1: 0,
      cpIndex2: 0,
      pzList: [],
      plList: [],
      value1: "",
      value10: [],
      btTitels: {},
      value2: "",
      queryForm: {
        propertId: "",
        propertId1:"",
        chemicalId: ""
      },
      rightTitles: {
        title: "",
        zbName: "",
        plTitle: "",
        cpTitle: ""
      },
      bannerList: {
        adverImage: ""
      },
      ncClassList: [],
      commonUrl,
      zbNameList: [], // 指标list
      wbfcOpt:{
          value: 'id',
          label: 'catgName',
          children: 'children'
        },
    };
  }
};
</script>


<style lang="less" scoped>
.indicator {
  width: 100%;
  // background:pink;
  .indicatorbanner {
    height: 234px;
    position: relative;
    // background: #2c6eff;
    // background: url('../../../../static/images/phbanner.png');
    .imgBg {
      z-index: 1;
      width: 100%;
      height: 234px;
      position: absolute;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .indicatorCon {
      position: relative;
      z-index: 999;
      width: 1180px;
      height: 234px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .leftBtn {
      
        width: 104px;
        height: 34px;
        // float: right;
        text-align: center;
        line-height: 34px;
        background-color: #ff964a;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
        margin-top: 20px;
      }
      .conleft {
        width: 795px;
        height: 234px;
        // display: flex;
        // align-items: center;
        // flex-wrap: wrap;
        .leftTitle {
          width: 720px;
          // height: 100px;
          font-size: 36px;
          color: #ffffff;
          line-height: 50px;
          margin: 46px 0 5px;
        }
        
        .leftTitle1 {
          width: 700px;
          height: 100px;
          font-size: 28px;
          color: #ffffff;
          line-height: 50px;
          margin: 46px 0 5px;
          overflow: hidden;
        }
        .leftCon {
          width: 795px;
          height: 56px;
          line-height: 28px;
          font-size: 20px;
          color: #ffffff;
        }
        
      }
    }
  }
  .liActive {
    background: #93ade6;
    border-radius: 20px;
  }
  .indicatorSearchBox {
    width: 1180px;
    margin: 0 auto;
    padding: 50px 0;
    .listTitle{
      margin: 0 auto 5px;
      height: 40px;
      font-family: PingFangSC-Semibold;
      font-size: 28px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #222222;
      font-weight:900;
      text-align:center;
    }
    .seeMoreBox{
      margin: 0 auto 30px;
      display: flex;
      justify-content: space-around;
      cursor: pointer;
    }
    .seeMore{
      font-size: 14px;
      color:#ff964a;
      display: flex;
      align-items: center;
    }
    .searchBox {
      height: 64px;
      background-color: #f2f5fa;
      border-radius: 4px;
      display: flex;
      align-items: center;
      padding-left: 20px;
      position: relative;
    }
    
    .rankingListBox {
      width: 100%;
      margin-top: 20px;
      height: 571px;
      background-color: #f2f5fa;
      box-shadow: 0px 2px 8px 0px #efefef;
      border-radius: 4px;
      display: flex;
      justify-content: space-between;
      padding: 20px;
      .box {
        width: 364px;
        .title {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #222222;
          padding-bottom: 15px;
          width: 364px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          .span2{
            // margin-left: 30px;
          }
        }
        .title1 {
          font-family: PingFangSC-Medium;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #222222;
          padding-bottom: 15px;
          width: 364px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .title2 {
          font-family: PingFangSC-Medium;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #222222;
          padding-bottom: 15px;
          width: 364px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .cont_no_data {
          width: 100%;
          height: 500px;
          display: flex;
          align-items: center; // 垂直居中，针对的是mycontainer类下面的子元素，不包含“孙子”元素
          justify-content: center; // 水平居中，针对的是mycontainer类下面的子元素，不包含“孙子”元素
          background-color: #ffffff;
          padding: 20px 0px;
          -webkit-box-shadow: 0px 2px 8px 0px #efefef;
          box-shadow: 0px 2px 8px 0px #efefef;
          border-radius: 4px;
          img {
            width: 120px;
            height: 120px;
          }
        }
        .cont_no_data1 {
          // width: 100%;
          height: 500px;
          display: flex;
          align-items: center; // 垂直居中，针对的是mycontainer类下面的子元素，不包含“孙子”元素
          justify-content: right; // 水平居中，针对的是mycontainer类下面的子元素，不包含“孙子”元素
          // background-color: #ffffff;
          // padding: 20px 0px;
          // -webkit-box-shadow: 0px 2px 8px 0px #efefef;
          // box-shadow: 0px 2px 8px 0px #efefef;
          // border-radius: 4px;
          img {
            width: 284px;
            height: 266px;
          }
        }
        .cont {
          width: 100%;
          height: 500px;

          ul {
            height: 100%;
            // display: flex;
            // flex-wrap: wrap;
            // justify-content: flex-start;
            // align-items: center;
            li {
              width: 100%;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0 18px 0 5px;
              cursor: pointer;
              margin-top: 10px;
              .rankingList_bg {
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
              .rankingList_bg0 {
                background: url("../../../../static/images/paihangbj1.png");
              }
              .rankingList_bg1 {
                background: url("../../../../static/images/paihangbj2.png");
              }
              .rankingList_bg2 {
                background: url("../../../../static/images/paihangbj3.png");
              }
              .rankingList_bg4 {
                background: url("../../../../static/images/paihangbj4.png");
              }
            }
          }
          ul li:nth-child(1) {
            margin-top: 0;
          }
          ul li .cont-1 {
            width: 24px;
            height: 25px;
            img {
              width: 24px;
              height: 25px;
            }
          }
          ul li .cont-2 {
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-left: 10px;
          }
          .cont-2-mr {
            background: #fff;
            border-radius: 20px;
          }
          ul li .cont-2 .div1 {
            img {
              width: 34px;
              height: 34px;
              border-radius: 17px;
              background-color: #feba13;
            }
          }
          ul li .cont-2 .div2 {
            width: 80px;
            font-family: PingFangSC-Medium;
            font-size: 13px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; // 默认不换行；
          }
          ul li .cont-2 .div3 {
            width: 60px;
            height: 4px;
          }
          ul li .cont-2 .div4 {
            width: 92px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
          }
        }
        // .cont{
        //   width: 100%;
        //   height: 500px;

        //   ul{
        //     width:100%;
        //     height: 100%;
        //     display: flex;
        //     flex-wrap: wrap;
        //     justify-content: space-between;
        //     align-items: center;
        //     li{
        //       display: flex;
        //       justify-content: space-between;
        //       align-items: center;

        //       .rankingList{
        //         margin-left: 13px;
        //         display: flex;
        //         justify-content: space-between;
        //         align-items: center;
        //         width: 318px;
        //         height: 48px;
        //         background-color: #ffffff;
        //         border-radius: 24px;
        //         padding: 4px 15px 4px 4px;
        //         .rankingList_bg{
        //             width: 40px;
        //             height: 40px;
        //             display: flex;
        //             align-items: center;
        //             justify-content: center;
        //         }
        //         .rankingList_bg0{
        //             background: url('../../../../static/images/paihangbj1.png');
        //         }
        //         .rankingList_bg1{
        //             background: url('../../../../static/images/paihangbj2.png');
        //         }
        //         .rankingList_bg2{
        //             background: url('../../../../static/images/paihangbj3.png');
        //         }
        //         .rankingList_bg4{
        //             background: url('../../../../static/images/paihangbj4.png');
        //         }
        //       }
        //       .rankingIcon{
        //         width: 25px;
        //         height: 25px;
        //     }
        //     }
        //   }
        //   ul li .rankingList div:nth-child(1){
        //     img{
        //       width: 34px;
        //       height: 34px;
        //       border-radius: 17px;
        //       background-color: #feba13;
        //     }
        //   }
        //   ul li .rankingList  div:nth-child(2){
        //     width:80px;
        //     font-family: PingFangSC-Medium;
        //     font-size: 13px;
        //     font-weight: normal;
        //     font-stretch: normal;
        //     letter-spacing: 0px;
        //     color: #333333;
        //     overflow: hidden; //超出的文本隐藏
        //     text-overflow: ellipsis; //溢出用省略号显示
        //     white-space: nowrap;  // 默认不换行；
        //   }
        //   ul li .rankingList div:nth-child(3){
        //     width: 80px;
        //     height: 4px;
        //   }
        //   ul li .rankingList div:nth-child(4){
        //     font-family: PingFangSC-Regular;
        //     font-size: 12px;
        //     font-weight: normal;
        //     font-stretch: normal;
        //     letter-spacing: 0px;
        //     color: #333333;
        //   }
        // }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Geographical/compontents/indicator.vue